import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearAuth } from "../../store/slices/authSlice";
import { clearUser } from "../../store/slices/userSlice";
import { userApi } from "../../repositories/user";
import { handleError } from "../../utils/errorHandler";
import Button from "../../components/ui/Button";

const HandleSubscription: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isRedirecting, setIsRedirecting] = useState<boolean>(false);

  useEffect(() => {

    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        setIsRedirecting(false);
      }
    };

    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);

  const handleManageSubscription = async () => {
    try {
      setIsRedirecting(true);
      const response = await userApi.createPortalSession();

      if (response?.data?.data?.url) {
        window.location.href = response.data.data.url;
      } else {
        console.error('No URL in response:', response);
        setIsRedirecting(false);
      }
    } catch (error) {
      handleError(error);
      setIsRedirecting(false);
    }
  };

  const handleLogout = () => {
    // Clear auth and user data
    dispatch(clearAuth());
    dispatch(clearUser());

    // Clear localStorage
    localStorage.removeItem("auth");

    // Navigate to login
    navigate("/auth/login");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 bg-neutral-50">
      <div className="w-full max-w-md p-8 bg-white border rounded-lg shadow-sm border-neutral-200">
        <div className="space-y-6 text-center">
          <div className="flex items-center justify-center w-16 h-16 mx-auto bg-danger-100 rounded-full">
            <svg
              className="w-10 h-10 text-danger-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <div>
            <h2 className="text-2xl font-semibold tracking-tight text-black">
              Subscription Payment Past Due
            </h2>
            <p className="mt-2 text-sm text-neutral-600">
              Your subscription payment is past due. Please update your payment
              method to continue accessing premium features.
            </p>
          </div>
          <div className="p-4 border rounded-md bg-danger-50 border-danger-200">
            <p className="text-sm text-danger-700">
              Access to all features has been restricted until payment is
              received. Please contact support or update your billing
              information.
            </p>
          </div>
          <div className="space-y-3">
            <Button
              onClick={handleManageSubscription}
              disabled={isRedirecting}
              className="w-full"
            >
              {isRedirecting ? "Redirecting..." : "Manage Subscription"}
            </Button>
            <Button
              variant="neutral"
              onClick={handleLogout}
              className="w-full"
            >
              Logout
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HandleSubscription;
